import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { c as clsx } from "../../../chunks/clsx-DgYk2OaC.js";
import { Text } from "../../../foundations/typography/Text/Text.js";
import { Radio } from "../../input/foundations/Radio/Radio.js";
import { s as styles } from "../../../chunks/Badge.module-DY1hgB_U.js";
const BadgeRadio = forwardRef(
  ({ children, value, className, ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      Radio,
      {
        ref,
        value,
        className: clsx(styles.badge, className),
        selectedClassName: styles.badgeIsSelected,
        pressedClassName: styles.badgeIsPressed,
        focusedClassName: styles.badgeIsFocused,
        ...props,
        children: /* @__PURE__ */ jsx(Text, { variant: "text-body-head", component: "span", className: styles.badgeText, children })
      }
    );
  }
);
export {
  BadgeRadio
};
